/*
 * @Date: 2024-07-19 12:53:28
 * @LastEditors: p彭 9878922+p-pengrulin@user.noreply.gitee.com
 * @LastEditTime: 2024-10-05 14:58:10
 */
import Request from "./commonRequest";

export const sendToLark = (data) => {
  if (data.text.includes("/send_message_to_lark")) return;

  return new Request("/send_message_to_lark").Post({
    data: data,
    suffix: "/data",
    mockedUrl: `/test/data/send_message_to_lark`,
  });
};

export const userreferral = (data) => {
  return new Request("/userreferral").Get({
    data: data,
    mockedUrl: `/dev/userreferral`,
  });
};

export const adduserreferral = (data) => {
  return new Request("/userreferral/update").Post({
    mockedUrl: `/dev/userreferral/update`,
    data: data,
  });
};

export const getAddressfromInviteCode = (data) => {
  return new Request("/userreferral/invitecode").Get({
    mockedUrl: `/dev/userreferral/invitecode`,
    data: data,
  });
};

export const newReferralUser = (data) => {
  return new Request("/userreferral/newuser").Post({
    mockedUrl: `/dev/userreferral/newuser`,
    data: data,
  });
};
